/* Runtime translation for copy that Translate & Adapt cannot reach.

   WHY THIS EXISTS: `luma-fx.js` BUILDS most of the PDP body at runtime from English string
   literals, overwriting whatever Liquid rendered, and `sections/luma-pdp.liquid` has no
   {% schema %}. Neither is visible to Translate & Adapt, so registering more locale keys
   could never fix them. This maps the rendered English to the target language instead,
   keyed on the source English, and re-applies whenever fx redraws.

   IT ALSO REPLACES luma-claims.js's REGEX. Those corrections matched English text
   ('60-night' -> '60-day', 'Proven Results' -> 'What to expect'), so translating the page
   would have silently stopped them firing and left false claims live in every language.
   Here a correction is just another map entry keyed on source English, so it survives
   translation by construction.

   WHITESPACE NORMALISATION (audit finding, 11 Aug) — do not remove.
   Two of the most prominent strings on every localized PDP were never translated: the top
   announcement bar and the "Shop all > Serums" breadcrumb. Both HAD translations. The
   lookup missed because the DOM renders &nbsp; (U+00A0) around the separators while the
   map keys were authored with ordinary spaces (U+0020) — same visible text, same length,
   different code points, and matching was byte-exact. Every lookup now also tries a
   normalised form (NBSP and friends folded to a single ordinary space). Replacement still
   writes the mapped value verbatim; only the KEY is normalised.

   Matching is on the whole trimmed text of a text node — never a substring — so it cannot
   corrupt prices, the '4.8, 2,537 sold' line, or anything not explicitly listed.

   KNOWN LIMIT: attributes (placeholder, title, alt, aria-label) are not translated. */
(function(){
  var MAP = window.LUMA_I18N;
  if (!MAP) return;

  var LANG = window.LUMA_I18N_LANG;
  if (LANG) document.documentElement.setAttribute('lang', LANG);

  /* fold NBSP / narrow-NBSP / thin space to a plain space, collapse runs */
  function norm(s){
    return s.replace(/[    ]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /* second index, keyed on the normalised source string */
  var NMAP = {};
  for (var k in MAP) {
    if (!Object.prototype.hasOwnProperty.call(MAP, k)) continue;
    var nk = norm(k);
    if (!(nk in NMAP)) NMAP[nk] = MAP[k];
  }

  var applied = 0;

  function lookup(t){
    var hit = MAP[t];
    if (hit !== undefined) return hit;
    return NMAP[norm(t)];
  }

  function walk(root){
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while (n = w.nextNode()) {
      var p = n.parentNode;
      if (!p) continue;
      var tag = p.nodeName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') continue;
      var raw = n.nodeValue;
      var t = raw.trim();
      if (!t) continue;
      var hit = lookup(t);
      if (hit === undefined) continue;
      /* keep the original leading/trailing whitespace so layout survives */
      n.nodeValue = raw.replace(t, hit);
      applied++;
    }
  }

  function run(){ walk(document.body); }

  var queued = false;
  function schedule(){
    if (queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; run(); });
  }

  if (document.body) run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  [60, 300, 800, 1600, 2600, 4000].forEach(function(d){ setTimeout(run, d); });

  function observe(){
    if (!document.body) return;
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.body) observe(); else document.addEventListener('DOMContentLoaded', observe);

  window.__lumaI18nCount = function(){ return applied; };
})();